import { Form } from './form'

export class AuthForm extends Form {
  constructor(form) {
    super(form)
    this.formFields = this.form.querySelectorAll('input, select, textarea')
    this.isDirty = this.isDirty.bind(this)

    this.initFields()
  }

  /**
   * Checks if field is dirty and applies the corresponding css class
   *
   * @param {Event} e Input Event
   */
  // eslint-disable-next-line class-methods-use-this
  isDirty(e) {
    const field = e.target
    if (field.value) {
      field.classList.add('dirty')
    } else {
      field.classList.remove('dirty')
    }
    field.classList.remove('invalid')
  }

  initFields() {
    this.formFields.forEach(field => {
      // Init Fields
      if (field.value || field.dataset.value) {
        field.classList.add('dirty')
      } else {
        field.classList.remove('dirty')
      }

      // Add Input event to watch value
      field.addEventListener('input', this.isDirty)
      field.addEventListener('change', this.isDirty)
    })
  }

  success(data) {
    const { message = '', redirect = '', reset = false } = data

    const files = this.form.querySelectorAll('[type="file"]')
    Array.from(files).forEach(fileInput => {
      fileInput.value = ''
    })

    document.dispatchEvent(new CustomEvent('form-success'))

    if (message) {
      this.showMessage(message)
    }

    if (reset) {
      this.form.reset()
    }

    if (redirect) {
      window.location.href = redirect
    }
  }
}

const authFormInit = {
  init() {
    const wrapperEl = document.querySelectorAll('.auth-form, .auth-form--underlined')
    Array.from(wrapperEl).forEach(form => new AuthForm(form))
  },
}

export default authFormInit
